var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseServerDataTable',{ref:"partnerFilter",attrs:{"setting":_vm.setting,"fnNew":_vm.$_new,"fnEdit":_vm.$_edit,"fnDelete":_vm.$_delete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }